import {
  FETCH_TEMPLATES_BEGIN,
  FETCH_TEMPLATES_SUCCESS,
  FETCH_TEMPLATES_FAILURE,
  OPEN_CREATE_TEMPLATE_MODAL,
  CLOSE_CREATE_TEMPLATE_MODAL,
} from "../actions/actionTypes";

const initialState = {
  error: null,
  loading: false,
  page: 1,
  totalPages: 0,
  totalEntries: 0,
  isCreateTemplateModalOpen: false,
  result: [],
};

export const templates = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_TEMPLATES_BEGIN:
      return {
        ...state,
        loading: true,
        page: action.payload.page,
        result: [],
      };
    case FETCH_TEMPLATES_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        totalPages: action.payload.totalPages || 0,
        totalEntries: action.payload.totalEntries || 0,
        result: action.payload.result,
      };
    case FETCH_TEMPLATES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    case OPEN_CREATE_TEMPLATE_MODAL:
      return {
        ...state,
        isCreateTemplateModalOpen: true,
      };
    case CLOSE_CREATE_TEMPLATE_MODAL:
      return {
        ...state,
        isCreateTemplateModalOpen: false,
      };
    default:
      return state;
  }
};

export default templates;
